<template>
    <b-card>
        <h4>
            History
            <b-badge style="float: right">
                <i class="fa fa-users"></i>
            </b-badge>
        </h4>
        <div class="ui container">
            <vuetable ref="vuetable"
                :http-fetch="fetchData"
                :api-mode="true"
                :api-url="this.$store.getters.apiBase + resources.events + '/' + event_id + resources.guests + '/' + guest_id + resources.history"
                :fields="fields"
                
                pagination-path="pagination"
                data-path=""
                :http-options="httpOptions()"
                @vuetable:pagination-data="onPaginationData">
            </vuetable>
            <vuetable-pagination
                ref="pagination" @vuetable-pagination:change-page="onChangePage">
            </vuetable-pagination>
        </div>
    </b-card>
</template>

<style>
.pagination a.item {
    padding: 10px;
}

.pagination a.item.large {
    font-weight: bolder
}
</style>


<script>
// import Vue from "vue";
import {Vuetable, VuetablePagination} from "vuetable-2";
import axios from "axios";

const RANGE_RGX = /^(?:items\s)?(\d+)-(\d+)\/(\d+)$/;

export default {
    name: "guestsHistory",
    props: ["event_id", "guest_id"],
    components: {
        Vuetable,
        VuetablePagination
    },
    data() {
        return {
            _fields: [
                {
                    name: "__sequence",
                    title: "#",
                    titleClass: "center aligned",
                    dataClass: "right aligned"
                },
                {
                    name: "id",
                    title: "id"
                },
                {
                    name: "type.action",
                    title: "Type"
                },
                {
                    name: "type.origin",
                    title: "Origin"
                },
                {
                    name: "date",
                    title: "Date"
                }
            ],
            resources: {
                events: "/events",
                guests: "/guests",
                history: "/history"
            },
            page: 1,
            perPage: 10,
            pages: []
        };
    },
    computed: {
        fields() {
            return this.$data._fields;
        }
    },
    methods: {
        fetchData(resource, options) {
            if (options && options.hasOwnProperty("params")) {
                options.headers["Range"] = "items=" + (options.params.page - 1) * options.params.per_page + "-";
                options.headers["Range"] += (options.params.page - 1) * options.params.per_page + options.params.per_page - 1;
            } else {
                options = {
                    params: {}
                };
            }

            const currentPage = options.params.page;
            const perPage = options.params.per_page;

            delete options.params.page;
            delete options.params.per_page;

            if (!options.params.sort) {
                delete options.params.sort;
            }
            return axios
                .get(resource, {
                    headers: {
                        "Content-Type": "application/json",
                        
                        Authorization: this.$store.getters.accessToken,
                        account_id: this.$store.getters.accountId
                    }
                })
                .then(response => {
                    try {
                        let m = RANGE_RGX[Symbol.match](
                            response.headers["content-range"]
                        );

                        const from = parseInt(m[1]);
                        const to = parseInt(m[2]);
                        const total = parseInt(m[3]);
                        response.data.pagination = {
                            total: total,
                            per_page: perPage,
                            current_page: currentPage,
                            last_page: Math.ceil(total / perPage),
                            from: from,
                            to: to
                        };

                    } catch (err) {
                        console.debug(err);
                    }
                    return response;
                })
                .catch(error => {
                    console.log(error);
                });
        },

        httpOptions() {
            const _headers = {
                "Content-Type": "application/json",
                
                Authorization: this.$store.getters.accessToken,
                        account_id: this.$store.getters.accountId
            };

            return {headers: _headers};
        },

        onPaginationData(paginationData) {
            this.$refs.pagination.setPaginationData(paginationData);
        },
        onChangePage(page) {
            this.$refs.vuetable.changePage(page);
        },
        editRow(rowData) {
            alert("You clicked edit on" + JSON.stringify(rowData));
        },
        deleteRow(rowData) {
            alert("You clicked delete on" + JSON.stringify(rowData));
        }
    },
    watch: {
        "$route": "fetchData"
    },
    created() {
        this.fetchData(this.$store.getters.apiBase + this.$data.resources.events + '/' + this.$props.event_id + this.$data.resources.guests + '/' + this.$props.guest_id + this.$data.resources.history);
    }
};
</script>